module.exports = __webpack_public_path__ + "static/home-bg-29a47979627932b91b1820c55368fd19.jpg";